import React from "react";
import { useAdminAuth } from "../context/AdminAuthContext";

const AccessDenied = () => {
  const { user } = useAdminAuth();

  return (
    <div className="page">
      <div className="card empty-state">
        <div className="empty-title">Access denied</div>
        <div className="empty-subtitle">
          {user?.email
            ? "Your account does not have an admin role yet."
            : "You are signed out."}
        </div>
        <div className="empty-helper">
          Ask a developer or super admin to assign an admin role in Firestore.
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
